import React, { CSSProperties } from 'react'

import { isPdfReport } from '@/lib/helpers/helperFunctions'
import { cn } from '@/lib/utils'

export interface FormGroupProps {
  children: React.ReactNode
  className?: string
  style?: CSSProperties
}

const FormGroup: React.FC<FormGroupProps> = ({
  children,
  className,
  style,
}) => (
  <div
    className={cn(
      'avoid-page-break',
      // In PDFs, we use mb-6! to ensure it overrides the margin-bottom style
      // from the avoid-page-break class
      isPdfReport() ? 'mb-6!' : 'mb-6',
      className,
    )}
    style={style}
  >
    {children}
  </div>
)

export default FormGroup
